import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSeller } from '../../context/SellerContext';
import SellerDetailPage from './SellerDetailPage';

/**
 * Marketplaces page — renders SellerDetailPage channels tab as a standalone page.
 */
export default function SellerMarketplacesPage() {
  const navigate = useNavigate();
  const { selectedSeller } = useSeller();

  if (!selectedSeller?.id) {
    navigate('/sellers', { replace: true });
    return null;
  }

  return <SellerDetailPage fixedTab="channels" sellerId={selectedSeller.id} />;
}
